function LabourCare() {
    return (
      <div className="container my-5">
        <h2 className="text-center mb-4">Labour Care Package</h2>
        
        <div className="card mb-4">
          <div className="card-header bg-warning text-dark">
            <h3>Care Protocol</h3>
          </div>
          <div className="card-body">
            <div className="row g-4">
              <div className="col-md-6">
                <h5>Pain Management</h5>
                <ul className="list-group">
                  <li className="list-group-item">Breathing techniques</li>
                  <li className="list-group-item">Hydrotherapy options</li>
                  <li className="list-group-item">Pharmacological options</li>
                </ul>
              </div>
              
              <div className="col-md-6">
                <h5>Delivery Preparation</h5>
                <ul className="list-group">
                  <li className="list-group-item">Continuous fetal monitoring</li>
                  <li className="list-group-item">Delivery room setup</li>
                  <li className="list-group-item">Emergency protocols</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  
        <div className="alert alert-success">
          <h4>Post-Delivery Plan</h4>
          <ul>
            <li>Immediate skin-to-skin contact</li>
            <li>Breastfeeding initiation support</li>
            <li>Postpartum recovery planning</li>
          </ul>
        </div>
      </div>
    );
  }


  export default LabourCare;